AFRAME.registerComponent('drag-move', {
    schema: {
        target: { type: 'selector' }
    },

    init: function () {
        this.dragging = false;
        this.raycasterEl = null;
        this.initialControllerPos = new THREE.Vector3();
        this.initialTargetPos = new THREE.Vector3();
        this.initialLocalPos = new THREE.Vector3();

        this.isMouseDrag = false;
        this.startMouse = { x: 0, y: 0 };
        this.currentMouse = { x: 0, y: 0 };

        this.onWindowMouseMove = this.onWindowMouseMove.bind(this);
        window.addEventListener('mousemove', this.onWindowMouseMove);

        this.el.addEventListener('raycaster-intersected', e => {
            this.raycasterEl = e.detail.el;
        });

        this.el.addEventListener('raycaster-intersected-cleared', e => {
            if (!this.dragging) {
                this.raycasterEl = null;
            }
        });

        this.el.addEventListener('triggerdown', () => {
            this.isMouseDrag = false;
            this.startDrag();
        });
        this.el.addEventListener('triggerup', () => this.stopDrag());

        this.el.addEventListener('mousedown', (e) => {
            this.isMouseDrag = !window.AppState.isTrueVRMode
            this.startDrag();
        });
        window.addEventListener('mouseup', () => this.stopDrag());

        const parsed = getCacheItem('mainSettings');
        this.autoRotatePanels = parsed?.autoRotatePanels !== false;
        this.el.sceneEl.addEventListener('rotate-panels-mode-changed', this.updateRotationMode.bind(this));
    },

    remove: function () {
        window.removeEventListener('mousemove', this.onWindowMouseMove);
    },

    onWindowMouseMove: function (e) {
        this.currentMouse.x = e.clientX;
        this.currentMouse.y = e.clientY;
    },

    getControllerPosition: function () {
        if (!this.raycasterEl) return null;

        const controllerPos = new THREE.Vector3();
        this.raycasterEl.object3D.getWorldPosition(controllerPos);
        return controllerPos;
    },

    startDrag: function () {
        if (!this.raycasterEl) return;

        this.dragging = true;

        if (this.isMouseDrag) {
            this.startMouse.x = this.currentMouse.x;
            this.startMouse.y = this.currentMouse.y;
            this.el.sceneEl.emit('drag-move-start');
        } else {
            const controllerPos = this.getControllerPosition();
            if (!controllerPos) return;
            this.initialControllerPos.copy(controllerPos);
        }
        if (!this.data.target || !this.data.target.object3D) return;
        this.data.target.object3D.getWorldPosition(this.initialTargetPos);

        this.initialLocalPos = this.data.target.object3D.position.clone();
    },

    stopDrag: function () {
        if (this.dragging && this.isMouseDrag) {
            this.el.sceneEl.emit('drag-move-end');
        }
        this.dragging = false;

        if (this.raycasterEl) {
            const intersection = this.raycasterEl.components.raycaster.getIntersection(this.el);
            if (!intersection) {
                this.raycasterEl = null;
            }
        }
    },

    tick: function () {
        if (!this.dragging) return;

        if (this.isMouseDrag) {
            const sensitivity = 0.005;
            const deltaX = (this.currentMouse.x - this.startMouse.x) * sensitivity;
            const deltaY = (this.currentMouse.y - this.startMouse.y) * sensitivity;

            const newLocalPos = this.initialLocalPos.clone();
            newLocalPos.x += deltaX;
            newLocalPos.y -= deltaY;
            if (newLocalPos.x > 5) newLocalPos.x = 5;
            if (newLocalPos.x < -5) newLocalPos.x = -5;
            if (newLocalPos.y > 5) newLocalPos.y = 5;
            if (newLocalPos.y < -3) newLocalPos.y = -3;


            if (!this.data.target || !this.data.target.object3D) return;
            this.data.target.object3D.position.copy(newLocalPos);

        } else {
            if (!this.raycasterEl) return;

            const currentControllerPos = this.getControllerPosition();
            if (!currentControllerPos) return;

            const deltaWorld = new THREE.Vector3().subVectors(currentControllerPos, this.initialControllerPos);

            const parent = this.data.target.object3D.parent;
            if (parent) {
                const parentQuaternion = new THREE.Quaternion();
                parent.getWorldQuaternion(parentQuaternion);

                const parentScale = new THREE.Vector3();
                parent.getWorldScale(parentScale);

                const inverseQuaternion = parentQuaternion.clone().invert();
                const deltaLocal = deltaWorld.clone().applyQuaternion(inverseQuaternion);

                deltaLocal.divide(parentScale);
                deltaLocal.multiplyScalar(5);
                const newLocalPos = this.initialLocalPos.clone().add(deltaLocal);

                this.data.target.object3D.position.copy(newLocalPos);
            } else {
                const newLocalPos = this.initialLocalPos.clone().add(deltaWorld.multiplyScalar(5));
                this.data.target.object3D.position.copy(newLocalPos);
            }
        }
        const cameraRig = document.querySelector('#cameraRig');
        if (!cameraRig) return;
        if (this.autoRotatePanels && (this.data.target.id === 'left-panel-2' || this.data.target.id === 'right-container' || this.data.target.id === 'search-center-panel')) {
            if (!this.data.target.classList.contains('billboard-y')) {

                this.data.target.classList.add('billboard-y');

                cameraRig.emit('update-billboards-list');
            }
            cameraRig.emit('update-billboards');
        }
        if (this.data.target.id === 'large-center-panel') {
            if (!cameraRig.object3D) return;
            const currentCameraPosition = new AFRAME.THREE.Vector3();
            cameraRig.object3D.getWorldPosition(currentCameraPosition);
            if (!this.data.target.object3D) return;
            const objectWorldPos = new AFRAME.THREE.Vector3();
            this.data.target.object3D.getWorldPosition(objectWorldPos);

            const direction = currentCameraPosition.clone().sub(objectWorldPos);
            const targetY = Math.atan2(direction.x, direction.z);
            const degrees = AFRAME.THREE.MathUtils.radToDeg(targetY);
            this.data.target.setAttribute('expected-panel-rotation', `0 ${degrees} 0`)
        }
    },

    updateRotationMode: function (e) {
        console.log('updateRotationMode', e)
        if (!e || !e.detail) return;

        this.autoRotatePanels = e.detail.autoRotatePanels;

        if (this.data.target.id === 'left-panel-2' || this.data.target.id === 'right-container' || this.data.target.id === 'search-center-panel') {
            const currentPosition = this.data.target.getAttribute('position');

            const currentPositionString = `${currentPosition.x} ${currentPosition.y} ${currentPosition.z}`;
            const defaultPos =  this.data.target.getAttribute('default-position');
            console.log('updateRotationMode pos', currentPosition, currentPositionString, defaultPos)
            this.data.target.classList.toggle('billboard-y', currentPositionString === defaultPos ? false : this.autoRotatePanels);

            cameraRig.emit('update-billboards-list');
            cameraRig.emit('update-billboards');
        }
    }
});
